module.exports = __webpack_public_path__ + "img/page-27.b5b3dd3d.jpg";